if (!customElements.get('fade-image-banners')) {
  class FadeImageBanners extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('fib--fade')) this._initFade();
    }

    _initFade() {
      const items = Array.from(this.querySelectorAll('.fib__banner-wrap'));

      const io = new IntersectionObserver(entries => {
        entries.forEach(e => e.target.classList.toggle('is-visible', e.isIntersecting));
      }, { threshold: 0.08 });

      items.forEach((item, i) => {
        item.style.transitionDelay = `${i * 90}ms`;
        item.classList.add('fib--item-fade');
        io.observe(item);
      });
    }
  }

  customElements.define('fade-image-banners', FadeImageBanners);
}
